import { Box } from "@chakra-ui/react";
import SectionHeader from "components/SectionHeader";

interface OverviewSectionProps {
  title: string;
  subtitle?: string;
  linkTo?: string;
  linkLabel?: string;
  children: React.ReactNode;
}

export default function OverviewSection({
  title,
  subtitle,
  linkTo,
  linkLabel = "View all →",
  children,
}: OverviewSectionProps) {
  return (
    <Box>
      <SectionHeader title={title} subtitle={subtitle} linkTo={linkTo} linkLabel={linkLabel} />
      <Box bg="white" border="1px solid" borderColor="gray.200" borderRadius="md" overflow="hidden">
        {children}
      </Box>
    </Box>
  );
}
